<template>
  <div class="layout-wrapper">
    <Headbar />
    <div class="layout-content">
      <router-view />
    </div>
    <Footerbar />
  </div>
</template>

<script>
import Headbar from "./Headbar/index.vue";
import Footerbar from "./Footerbar/index.vue";

export default {
  name: "Layout",
  components: {
    Headbar,
    Footerbar,
  },
};
</script>

<style scoped>
.layout-wrapper {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
.layout-content {
  flex: 1;
  padding-bottom: calc(64px + env(safe-area-inset-bottom, 0px));
}
</style>
